<template>
  <li class="msg-item" v-if="msgType === 'txt'">
    <span class="role" :style="{ backgroundColor: role.color }">{{ role.type }}</span>
    <el-popconfirm v-if="isBan && ![1, 2, 3, 7].includes(msg.perm)" title="禁言该用户吗？" :key="`${msg.mid}-forbidden`" @confirm="confirmForbidden">
      <span class="name" slot="reference">{{ name }}</span><span>：</span>
    </el-popconfirm>
    <span v-else class="name" slot="reference">{{ name }}</span><span>：</span>

    <el-popconfirm v-if="isDel" title="删除该条消息？" :key="`${msg.mid}-del`" @confirm="confirmDel">
      <span class="content" slot="reference" v-format-emoji v-html="msg.content"></span>
    </el-popconfirm>

    <span v-else class="content" slot="reference" v-format-emoji v-html="msg.content"></span>
  </li>
  <li class="msg-item notice enter" v-else-if="msgType === 'system'">
    {{ msg.content }}
  </li>
</template>

<script>
export default {
  name: 'msg-item',
  props: {
    msg: Object,
    isDel: [Boolean, Number],
    isBan: [Boolean, Number]
  },
  computed: {
    msgType () {
      return this.msg.content_type
    },
    name () {
      let name = this.msg.nickname
      const nameReg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (nameReg.test(name)) {
        var reg = /^(\d{3})\d*(\d{4})$/;
        name = name.replace(reg, '$1****$2')
      }
      return name
    },
    role () {
      const msg = this.msg
      let role = {
        color: '',
        type: '普通'
      }
      if (msg.perm) {
        var type = msg.perm
        try {
          switch (Number(type)) {
            case 1:
              role = {
                color: '#ff919f',
                type: '管理员'
              }
              break;
            case 2:
              role = {
                color: '#94abff',
                type: '客服'
              }
              break;
            case 3:
              role = {
                color: '#b78fff',
                type: '主播'
              }
              break;
            case 4:
              role = {
                color: '',
                type: '普通'
              }
              break;
            case 5:
              role = {
                color: '',
                type: '推荐师'
              }
              break;
            case 6:
              role = {
                color: '#4fe069',
                type: '老球迷'
              }
              break;
            case 7:
              role = {
                color: '#94abff',
                type: '助理'
              }
              break;
            default:
              break;
          }
        } catch (err) {
          console.log(err)
        }
      }
      return role
    }
  },
  methods: {
    confirmForbidden () {
      console.warn('confirmForbidden', this.msg)
      this.$emit('forbidden', this.msg)
    },
    confirmDel () {
      console.warn('confirmDel', this.msg)
      this.$emit('delmsg', this.msg)
    }
  }
}
</script>

<style lang="less" scoped>
.msg-item {
  margin-bottom: 5px;
  &.notice {
    color: #ffa200;
    font-size: 14px;
    line-height: 18px;
  }
  .role {
    display: inline-block;
    line-height: 18px;
    font-size: 12px;
    background: #ffd874;
    color: #fff;
    border-radius: 5px;
    width: 46px;
    text-align: center;
    margin-right: 5px;
  }
  .name {
    display: inline-block;
    max-width: 100px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: #00baff;
    font-size: 14px;
    vertical-align: bottom;
    line-height: 18px;
    cursor: pointer;
  }
  .content {
    word-break: break-word;
    line-break: anywhere;
    font-size: 14px;
    vertical-align: bottom;
    line-height: 20px;
    cursor: pointer;
    /deep/ img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
